import geral from '../services/geral'
import modules from '../modules/Services'

export default { ...geral, ...modules }



// WEBPACK FOOTER //
// ./src/services/index.js